<div class="sidenav-container" [ngClass]="{ 'has-env-banner': showEnvironmentBanner }">
  <div class="top-bar">
    <button mat-icon-button (click)="navigationService.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <a *ngIf="navigationService.opened" routerLink="./">
      <svg fxHide [fxShow.gt-sm]="true" viewBox="0 0 97.73 16.02" class="me-slalom-logo-svg">
        <use xlink:href="assets/me-logo-small.svg#me-slalom-logo"></use>
      </svg>
      <svg fxShow [fxHide.gt-sm]="true" viewBox="0 0 97.73 16.02" class="m-at-s-logo-svg">
        <use xlink:href="assets/m_at_s_logo.svg#me-slalom-logo"></use>
      </svg>
    </a>
  </div>

  <ul class="menu-items">
    <li
      *ngFor="let item of sideNavItems"
      class="menu-item"
      [ngClass]="{
        opened: navigationService.opened
      }"
      routerLink="/{{ item.url }}"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: item.url === '/' }"
      (click)="onNavSelection()"
      (mouseenter)="setHover(item.name)"
      (mouseleave)="closeHover()"
    >
      <!-- <svg *ngIf="item.disabled" width="20" height="21" fill="#C4C4C4">
        <rect y="0.5" width="20" height="20"/>
      </svg> -->

      <mat-icon [ngClass]="{ hover: hoverName === item.name }">{{ item.icon }}</mat-icon>
      <div *ngIf="hoverName === item.name && !navigationService.opened" class="hover-label">
        {{ item.name }}
      </div>
      <div
        [ngClass]="{ hover: hoverName === item.name }"
        *ngIf="navigationService.opened"
        test-filter="target"
        class="menu-text"
      >
        {{ item.name }}
      </div>
    </li>
  </ul>
</div>
